module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAh0lEQVR4AWOgC7hq4UEkQmhgCDhBEOHUwO53qCWipzm8G8ggSkOK5+Tik6tLTq5J9ppMlIYlXZurLm6tu7pvcedGojRsXXL4wOXH+y/d37RwH1EaGstXTD9zN2TZiqqCbqI0RDu1Fa2cPWF1TZJLM5GhdHhyZM6MmGw2v8PI4uTEA+kxPSgBANuiwor8jwQvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GU.png
// module id = 1156
// module chunks = 0